import { update } from "lodash";

export default {
  data() {
    return {
      discountCode:{
        code:""
      }
      // discountCode: {
      //   code: "",
      //   count: "",
      //   useState: false,
      //   limitModel: "buyMoney",
      //   discountModel: "percentage",
      //   discountValue: 0,
      //   limitValue: 0,
      //   time: {
      //     startTime: this.$moment().format("YYYY-MM-DD"),
      //     endTime: this.$moment().add(1, "month").format("YYYY-MM-DD")
      //   },
      //   remark: ""
      // }
      
    }
  },
  created(){
    let temp = {
      code: "",
      count: "",
      useState: false,
      limitModel: "buyMoney",
      discountModel: "percentage",
      discountValue: 0,
      limitValue: 0,
      time: {
        startTime: this.$moment().format("YYYY-MM-DD"),
        endTime: this.$moment().add(1, "month").format("YYYY-MM-DD")
      },
      remark: ""
    }
    if (this.$props.method == 'update') {
      temp =  JSON.parse(JSON.stringify(this.$props.discountTemp));
    }
    this.discountCode=temp;
  },
  computed: {
    openModel: {
      get() {
        return this.$props.open;
      },
      set(data) {
        this.$emit("update:open", data);
      }
    },

    discountRange() {
      const discountRange = [{
        value: "0",
        text: "不使用"
      }];
      for (let i = 9.9; i > 0; i -= 0.1) {
        discountRange.push({
          value: i.toFixed(1),
          text: i.toFixed(1)
        });
      }
      return discountRange;
    },
  },

  methods: {
    changeLimitAndMethod(method) {
      (method == "limit") ? this.discountCode.limitValue = 0: "";
      (method == "model") ? this.discountCode.discountValue = 0: "";
    },

   async autoDiscountCode() {
      // const codeLength = Math.round(Math.random() * 5) + 6;
      // const eleArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e',
      //   'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
      //   'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
      //   'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
      // ];

      // let code = "";

      // for (let i = 1; i < codeLength; i++) {
      //   const temp = Math.round(Math.random() * (eleArr.length - 1));
      //   code += eleArr[temp];
      // }

      const a = await this.$store.dispatch("cart/autoDiscountCode").then((data)=>{return data;});
      console.log(a);
      this.discountCode.code=a;
    },

    saveDiscountCode(event) {
      this.$store.dispatch("cart/discountCodeSave", this.discountCode);
    }
  },

  props: {
    method: {
      type: String
    },
    discountTemp: {
      type: Object
    },
    open: {
      type: Boolean
    }
  }
}
